import { createRouter, createWebHistory } from 'vue-router';
import { listRouter } from './autoRouter';
import { ElMessage } from 'element-plus';
import { getItem, setItem } from '@/utils/localStorage';
import { getUserInfo } from '@/apis/login';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL || '/'),
    routes: listRouter,
    scrollBehavior: (to, from, savedPosition) => {
        return { left: 0, top: 0 }; // 强制滚动到顶部
    },
});
// 白名单不需要登录
let isFirstReqestUserInfo = true;
const whitePage = [
    '/home',
    '/flag-cx',
    '/flag-gems',
    '/flag-release',
    '/flag-scale',
    '/flag-tree',
    '/learn-center',
    '/community',
    '/issue-form',
    '/issue-detail',
];
router.beforeEach(async (to, from, next) => {
    const { setUserInfo } = useStore('user');
    if (to.path === '/login') {
        // 只有在有 token 的情况下才调用 getUserInfo
        if (getItem('data-appToken', 'ls')) {
            try {
                const userInfo = await getUserInfo(false);
                userInfo && setUserInfo(userInfo.userResponse);
            } catch {
                // 获取用户信息失败，已自动清除用户信息和 token，继续执行
            }
        }
        next();
        return;
    }
    // 检查是否在白名单中（支持动态路由参数）
    const isInWhitePage = whitePage.some(page => to.path === page || to.path.startsWith(page + '/'));
    if (isInWhitePage) {
        if (isFirstReqestUserInfo && getItem('data-appToken', 'ls')) {
            isFirstReqestUserInfo = false;
            try {
                const userInfo = await getUserInfo(false);
                userInfo && setUserInfo(userInfo.userResponse);
            } catch {
                // 获取用户信息失败，已自动清除用户信息和 token，继续执行
            }
        }
        next();
        return;
    } else {
        // 只有在有 token 的情况下才调用 getUserInfo
        if (isFirstReqestUserInfo && getItem('data-appToken', 'ls')) {
            isFirstReqestUserInfo = false;
            try {
                const userInfo = await getUserInfo();
                userInfo && setUserInfo(userInfo.userResponse);
            } catch {
                // 获取用户信息失败，已自动清除用户信息和 token，继续执行
            }
        }
    }

    next();
});

// 跳转登录之前保存当前路径，登录之后返回原来路径
router.beforeEach((to, from, next) => {
    if (to.path.startsWith('/login') && from.fullPath !== '/' && from.path !== '/login') {
        setItem('redirect_url', location.href);
    }
    next();
});
// 百度统计默认只统计 首次加载，
// Vue 是 SPA，切路由必须手动上报 URL，否则后台只显示一个页面访问！
router.afterEach(to => {
    if ((window as any)._hmt) {
        (window as any)._hmt.push(['_trackPageview', to.fullPath]);
    }
});

router.onError((err, to, from) => {
    if (err) {
        ElMessage({ message: '数据更新，刷新页面获取最新数据' });
    }
    console.error('Router error:', err, to, from);
});
export default router;
